const backendApi = {
  "production": {
    "healthData_url": "https://healthriskbackend.docsapp.in/healthData"
  },
  "development": {
    "healthData_url": "http://localhost:3074/healthData"
  }
}

const url = {
  "userDetails": "https://www.medibuddy.in/WAPI/MarketPlaceLogon"
}

if(process.env.NODE_ENV === "production") console.log = function(){}

const config = { ...backendApi[process.env.NODE_ENV], ...url }

export default config;